<template>
    <div class="my-2" ref="search" :style="`--tabHighlightColor: ${tabHighlightColor}; --tabHighlightTextColor: ${tabHighlightTextColor}`">
        <div class="relative">
            <div class="overflow-hidden relative w-full px-1">
                <div class="tabcontainer" ref="tabContainer" @scroll="updateArrowVisibility">
                    <div v-for="(group, label) in groupedTags" :key="label" class="relative max-w-xs inline-block lg:block" ref="dropdowns">
                        <button class="tab" :class="{ 'active': activeMenu.label === label }" @click="setActiveMenu(label, group)">
                            {{ label }}
                        </button>
                    </div>
                </div>
                <svg @click="scrollTabsLeft" class="cursor-pointer arrow left-[1px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="showLeftArrow">
                    <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                    <path d="M15 12H9M12 8L8 12L12 16" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg @click="scrollTabsRight" class="cursor-pointer arrow right-[1px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="showRightArrow">
                    <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                    <path d="M9 12h6M12 16l4-4-4-4" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>

        <div class="mx-1 lg:mx-0 border border-black rounded-lg overflow-hidden bg-gray-100 text-xs lg:text-sm">
            <div class="relative">
                <div class="static-tags" ref="baseActiveMenu" @scroll="updateArrowVisibility">
                    <div v-if="activeMenu" v-for="tag in activeMenu.group" :key="tag.title" class="relative max-w-xs inline-block lg:block">
                        <button class="btn mx-1 px-1" :class="{ 'active': selectedTags.includes(tag.title) }" @click.prevent="toggleTag(tag.title)">
                            {{ tag.title }}
                        </button>
                    </div>
                </div>
                <svg @click="scrollTagsLeft" class="cursor-pointer arrow left-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="showTagsLeftArrow">
                    <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                    <path d="M15 12H9M12 8L8 12L12 16" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg @click="scrollTagsRight" class="cursor-pointer arrow right-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="showTagsRightArrow">
                    <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                    <path d="M9 12h6M12 16l4-4-4-4" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            
            <div class="flex flex-col py-2 border-t border-b border-black text-xs px-1 lg:px-2 justify-center items-center">
                <div class="flex flex-row  justify-center items-center pb-1">
                    <button @click="addFilterCondition('and')" class="btn p-1 mx-1">And</button>
                    <button @click="addFilterCondition('or')" class="btn p-1 mx-1">Or</button>
                    <input type="checkbox" class="mx-1 my-auto" v-model="showOffline" aria-label="Sort offline"/> Sort Offline
                </div>
                <div class="text-[8px] leading-none">Offline at bottom</div>
            </div>

            <div class="flex flex-col">
                <div v-for="(condition, index) in filterConditions" :key="index" class="flex flex-col border-b border-black">
                    <div class="font-semibold mx-auto mb-1 sm:mb-0">{{ capitalizedOperator(condition.operator) }}</div>
                    <div class="relative">
                        <div class="tabcontainer" :ref="'conditionTabContainer-' + index" @scroll="updateArrowVisibility">
                            <div v-for="(group, label) in groupedTags" :key="label" class="relative max-w-xs inline-block lg:block" ref="dropdowns">
                                <button class="tab" :class="{ 'active': condition.activeMenu && condition.activeMenu.label === label }" @click="setActiveConditionMenu(index, label, group)">
                                    {{ label }}
                                </button>
                            </div>
                            <svg @click="scrollConditionTabsLeft(index)" class="cursor-pointer arrow left-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="conditionArrowStates[index] && conditionArrowStates[index].showLeftArrow">
                                <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                                <path d="M15 12H9M12 8L8 12L12 16" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <svg @click="scrollConditionTabsRight(index)" class="cursor-pointer arrow right-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="conditionArrowStates[index] && conditionArrowStates[index].showRightArrow">
                                <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                                <path d="M9 12h6M12 16l4-4-4-4" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div class="relative">
                        <div class="static-tags border-t border-black" :ref="'conditionTagContainer-' + index" @scroll="updateArrowVisibility">
                            <div v-if="condition.activeMenu" v-for="tag in condition.activeMenu.group" :key="tag.title"  class="relative max-w-xs inline-block lg:block">
                                <button class="btn mx-1 px-1" :class="{ 'active': condition.selectedTags.includes(tag.title) }" @click.prevent="toggleConditionTag(index, tag.title)">
                                    {{ tag.title }}
                                </button>
                            </div>
                        </div>
                        <svg @click="scrollConditionTagsLeft(index)" class="cursor-pointer arrow left-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="conditionTagArrowStates[index] && conditionTagArrowStates[index].showLeftArrow">
                            <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                            <path d="M15 12H9M12 8L8 12L12 16" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg @click="scrollConditionTagsRight(index)" class="cursor-pointer arrow right-[-3px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-show="conditionTagArrowStates[index] && conditionTagArrowStates[index].showRightArrow">
                            <rect x="4" y="4" width="16" height="16" stroke="black" stroke-width="1" fill="white"/>
                            <path d="M9 12h6M12 16l4-4-4-4" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="flex flex-col flex-wrap border-b border-black text-xs">
                <div class="px-3 lg:px-4">
                    Base Tags:
                    <div class="btn inline-flex items-center mx-1 px-1" v-for="(tag, index) in selectedTags" :key="'base-' + index" @click="removeBaseTag(index)">
                        {{ tag }}
                        <button class="font-bold ml-1">×</button>
                    </div>
                </div>
                <div class="border-t border-black px-3 lg:px-4" v-for="(filterCondition, conditionIndex) in filterConditions" :key="'condition-' + conditionIndex">
                    {{ capitalizedOperator(filterCondition.operator) }} Tags:
                    <div class="btn inline-flex items-center mx-1 px-1" v-for="(tag, index) in filterCondition.selectedTags" :key="filterCondition.operator + '-' + index" @click="removeConditionTag(conditionIndex, index)">
                        {{ tag }}
                        <button class="font-bold ml-1">×</button>
                    </div>
                </div>
            </div>

            <div class="flex flex-row items-center p-2 lg:pl-3 justify-between">
                <div class="flex flex-grow">
                    <input
                        type="text"
                        v-model="searchQuery"
                        placeholder="Search..."
                        class="w-full py-1 font-medium rounded-md bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-300 flex-shrink"
                    />
                </div>
                <div class="flex flex-row items-center ml-2">
                    <span class="text-xs lg:text-sm min-w-fit">Results: {{ filteredChannels.length }}</span>
                    <button @click="resetFilters" class="btn ml-2 px-2 py-1">Reset</button>
                </div>
            </div>
        </div>

        <div v-if="filteredChannels.length === 0 && channels.length != 0 && isOnlineLoaded != false" class="flex flex-col items-center justify-center mt-8 text-white text-outline">
            <h1 class="text-2xl">No Results Found</h1>
            <p class="text-sm">Try adjusting your filters or search query.</p>
        </div>

        <div v-if="channels.length === 0 && isOnlineLoaded != false" class="flex flex-col items-center justify-center mt-8 text-white text-outline">
            <h1 class="text-2xl">No Channels currently online</h1>
        </div>
        
        <div v-show="isOnlineLoaded" id="channels-grid" class="px-1 lg:px-0 channels-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 overflow-y-auto relative">
            <div
                v-for="channel in filteredChannels"
                :key="channel.name"
                :data-tags="tagsByUserId[channel.userId].map(tag => tag.tag).join(',')"
                class="channel-card bg-gray-100 rounded-md flex flex-col w-full mx-auto max-w-sm border-2 border-black"
                loading="lazy"
                >

                <img
                    class="w-full h-48 object-cover rounded-t border-b border-black"
                    @click="changeChannel(channel.name)"
                    :src="getThumbnailUrl(channel.thumbnail)"
                    alt="Channel Thumbnail"
                    style="object-fit: cover;"
                    loading="lazy"
                    />

                <div id="cardBanner" class="grid grid-cols-3">
                    <div id="profilePic" class="">
                        <img class="ring-2 ring-indigo-500 rounded-full mx-auto bg-gray-100" style="width: 100px; height: 100px; margin-top: -33px;" :src="channel.profilePic" alt="Profile Image" loading="lazy">
                    </div>

                    <div id="streamInfo" class="mx-auto w-full max-w-full text-center whitespace-normal self-end">
                        <div class="font-bold border-b border-gray-500 max-w-full leading-none">
                            <div class="channel-name -mx-8">{{ channel.name }}</div>
                        </div>
                    </div>

                    <div id="gamePic" class="">
                        <img class="mx-auto border-2 rounded border-indigo-500" style="margin-top: -16px;" :src="'https://static-cdn.jtvnw.net/ttv-boxart/' + channel.gameId + '-60x81.jpg'" alt="Game Image" loading="lazy">
                    </div>
                </div>

                <div class="text-xs text-center pt-1 leading-none">{{ channel.game ? channel.game : 'No Current Game' }}</div>

                <div class="text-sm grid grid-cols-3 justify-between mt-1 pt-1 px-1 border-t border-black" style="line-height: 1;">
                    <div class="text-center"><p class="underline mb-1 font-semibold">Pronouns</p><span class="pronouns text-xs leading-none"> {{ getPronoun(channel.userId) }}</span></div>
                    <div class="text-center"><p class="underline mb-1 font-semibold">Followers</p><span class="text-xs">{{ getFollows(channel.userId) }}</span></div>
                    <div class="text-center"><p class="underline mb-1 font-semibold">Viewers</p><span class="text-xs">{{ channel.viewers }}</span></div>
                </div>

                <div id="description" class="p-3 text-sm flex-shrink-0">
                    <p>{{ channel.description }}</p>
                </div>

                <div class="flex flex-row flex-wrap border-t border-gray-500 mt-auto text-xs px-2">
                    <div class="font-bold w-full">Tags</div>
                    <div
                        class="btn inline-flex items-center mr-1 px-1 text-xs bg-gray-100 hover:bg-gray-300 text-gray-800 border border-black"
                        :class="{
                            'font-bold': tag.importance === '1',
                            'hidden': tag.importance === '3'
                        }"
                        v-for="tag in tagsByUserId[channel.userId]"
                        :key="tag.tag"
                        @click="selectTag(tag.tag)"
                        style="cursor: pointer;"
                    >
                        {{ tag.tag }}
                    </div>
                </div>

                <div id="cardLinks" class="gap-2 p-2" :class="{'grid grid-cols-2': !isCharityComponentActive,'grid grid-cols-1': isCharityComponentActive}">
                    <button v-show="!isCharityComponentActive" class="btn" @click="changeChannel(channel.name)">Watch here</button>
                    <a class="btn" :href="'https://www.twitch.tv/' + channel.name" target="_blank">Visit Channel</a>
                </div>
            </div>
        </div>

        <!-- Offline channels section -->
        <div v-if="isOfflineLoaded" class="offline-section mt-8">
            <button @click="isOfflineSectionCollapsed = !isOfflineSectionCollapsed" class="bg-gray-100 w-full px-4 py-2 rounded-md">
                {{ isOfflineSectionCollapsed ? 'Show' : 'Hide' }} Offline Channels ({{ filteredOfflineChannels.length }})
            </button>
            <div v-if="!isOfflineSectionCollapsed" class="px-1 lg:px-0 channels-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 overflow-y-auto relative">
                <div v-for="channel in filteredOfflineChannels" :key="channel.userId" class="channel-card bg-gray-100 rounded-md flex flex-col w-full mx-auto max-w-sm border-2 border-black" :data-tags="tagsByUserId[channel.userId].map(tag => tag.tag).join(',')" loading="lazy">
                    <div id="cardBanner" class="grid grid-cols-3 mt-1">
                        <div id="profilePic" class="">
                            <img class="ring-2 ring-indigo-500 rounded-full mx-auto" style="width: 100px; height: 100px;" :src="channel.profilePic" alt="Profile Image" loading="lazy">
                        </div>

                        <div id="streamInfo" class="mx-auto w-full max-w-full text-center whitespace-normal self-end">
                            <div class="font-bold border-b border-gray-500 max-w-full leading-none">
                                <div class="channel-name">{{ channel.name }}</div>
                            </div>
                        </div>

                        <div id="gamePic" class="self-end">
                            <img class="mx-auto border-2 rounded border-indigo-500 bg-gray-100" style="" :src="'https://static-cdn.jtvnw.net/ttv-boxart/' + channel.gameId + '-60x81.jpg'" alt="Game Image" loading="lazy">
                        </div>
                    </div>

                    <div class="text-xs text-center pt-1 leading-none">{{ channel.gameName }}</div>

                    <div class="text-sm grid grid-cols-3 justify-between mt-1 pt-1 px-1 border-t border-black" style="line-height: 1;">
                        <div class="text-center"><p class="underline mb-1 font-semibold">Pronouns</p><span class="pronouns text-xs leading-none"> {{ getPronoun(channel.userId) }}</span></div>
                        <div class="text-center"><p class="underline mb-1 font-semibold">Followers</p><span class="text-xs">{{ channel.followers }}</span></div>
                        <div class="text-center" v-if="mostRecentDate(channel)">
                            <p class="underline mb-1 font-semibold">{{ mostRecentDateLabel(channel) }}</p>
                            <span class="text-xs leading-none">
                                <span v-html="formatDateWithLineBreak(mostRecentDate(channel))"></span>
                            </span>
                        </div>
                    </div>

                    <p class="p-3 text-sm flex-shrink-0">{{ channel.description }}</p>

                    <div class="flex flex-row flex-wrap px-2 mt-auto border-t border-gray-500 text-xs">
                        <div class="font-bold w-full">Tags</div>
                        <div
                            class="btn inline-flex items-center mx-1 px-1 text-xs bg-gray-100 hover:bg-gray-300 text-gray-800 border border-black"
                            :class="{
                                'font-bold': tag.importance === '1',
                                'hidden': tag.importance === '3'
                            }"
                            v-for="tag in (tagsByUserId[channel.userId] || [])"
                            :key="tag.tag"
                            @click="selectTag(tag.tag)"
                            style="cursor: pointer;"
                        >
                        {{ tag.tag }}
                        </div>
                    </div>
                    <div class="gap-2 p-2 grid grid-cols-1">
                        <a class="btn" :href="'https://www.twitch.tv/' + channel.name" target="_blank">Visit Channel</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-center text-white text-outline">
                Offline channels unavailable, try again soon.
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { debounce } from 'lodash';
  export default {
    name: 'ChannelCards',
    props: {
        tabHighlightColor: String,
        tabHighlightTextColor: String,
    },
    data() {
      return {
        users: [],
        usersById: [],
        channels: [],
        expandedCategory: null,
        tags: [],
        tagsByUserId: {},
        selectedTags: [],
        userIds: [],
        categories: [],
        groupedTags: [],
        usersLoaded: false,
        isLoaded: false,
        isOnlineLoaded: false,
        isOfflineLoaded: false,
        activeMenu: { label: '', group: [] },
        shuffleInstance: null,
        numResults: 0,
        filterConditions: [],
        filteredCount: null,
        searchQuery: '',
        channelsGrid: null,
        scrollArrow: null,
        arrowUpdateTrigger: 0,
        conditionArrowStates: {},
        conditionTagArrowStates: {},
        offlineChannels: [],
        onlyOfflineChannels: [],
        isOfflineSectionCollapsed: true,
        showOffline: null,
      };
    },
    async created(){
        
    },
    async mounted() {
        await this.fetchData();
        this.$nextTick(() => {
            this.updateArrowVisibility();
        }); 
    },
    updated() {
    },
    watch: {
        isOfflineSectionCollapsed(newValue) {
            if (!newValue) {
            this.$nextTick(() => {
                fitty('.channel-name');
                fitty.fitAll();
            });
            }
        },
    },
    computed: {
        ...mapState(['isCharityComponentActive']),
        filteredChannels() {
            if (!this.isOnlineLoaded) { // Check if online data is loaded
                return [];
            }

            return this.channels.filter(channel => {
                const tags = this.tagsByUserId[channel.userId].map(tag => tag.tag);
                const query = this.searchQuery.toLowerCase().trim();
                const nameMatch = channel.name.toLowerCase().includes(query);
                const gameMatch = channel.game.toLowerCase().includes(query);
                const pronounMatch = this.getPronoun(channel.userId).toLowerCase().includes(query);
                const tagsMatch = tags.some(tag => tag && tag.toLowerCase().includes(query));
                const baseMenuMatch = this.selectedTags.length === 0 || this.selectedTags.some(tag => tags.includes(tag));
                const filterConditionMatch = this.filterConditions.reduce((result, condition) => {
                const conditionTags = condition.selectedTags;
                if (conditionTags.length === 0) {
                    return result;
                }
                if (condition.operator === 'and') {
                    return result && conditionTags.every(tag => tags.includes(tag));
                } else if (condition.operator === 'or') {
                    return result || conditionTags.some(tag => tags.includes(tag));
                }
                return result;
                }, baseMenuMatch);
                return (nameMatch || gameMatch || pronounMatch || tagsMatch) && baseMenuMatch && filterConditionMatch;
            });
        },
        filteredOfflineChannels() {
            if(this.showOffline){
                return this.onlyOfflineChannels.filter(channel => {
                    const tags = this.tagsByUserId[channel.userId].map(tag => tag.tag);
                    const query = this.searchQuery.toLowerCase().trim();
                    const nameMatch = channel.name.toLowerCase().includes(query);
                    const pronounMatch = this.getPronoun(channel.userId).toLowerCase().includes(query);
                    const tagsMatch = tags.some(tag => tag && tag.toLowerCase().includes(query));
                    const baseMenuMatch = this.selectedTags.length === 0 || this.selectedTags.some(tag => tags.includes(tag));
                    const filterConditionMatch = this.filterConditions.reduce((result, condition) => {
                    const conditionTags = condition.selectedTags;
                    if (conditionTags.length === 0) {
                        return result;
                    }
                    if (condition.operator === 'and') {
                        return result && conditionTags.every(tag => tags.includes(tag));
                    } else if (condition.operator === 'or') {
                        return result || conditionTags.some(tag => tags.includes(tag));
                    }
                    return result;
                    }, baseMenuMatch);
                    return (nameMatch || pronounMatch || tagsMatch) && baseMenuMatch && filterConditionMatch;
                });
            }else{
                return this.onlyOfflineChannels;
            }
        },
        formatDateWithLineBreak() {
            return (date) => {
                if (!date) {
                    return 'None';
                }

                const dateObj = typeof date === 'number' ? new Date(date * 1000) : new Date(date);

                const timeFormatter = new Intl.DateTimeFormat('en-US', {
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZoneName: 'short',
                });

                const dateFormatter = new Intl.DateTimeFormat('en-US', {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                });

                const formattedTime = timeFormatter.format(dateObj);
                const formattedDate = dateFormatter.format(dateObj);

                return `${formattedDate}<br>${formattedTime}`;
            };
        },
        showLeftArrow() {
            this.arrowUpdateTrigger;
            return this.$refs.tabContainer && this.$refs.tabContainer.scrollLeft > 0;
        },
        showRightArrow() {
            this.arrowUpdateTrigger;
            const tabContainer = this.$refs.tabContainer;
            return tabContainer && tabContainer.scrollWidth > tabContainer.clientWidth && tabContainer.scrollLeft < tabContainer.scrollWidth - tabContainer.clientWidth;
        },
        showTagsLeftArrow() {
            this.arrowUpdateTrigger;
            return this.$refs.baseActiveMenu && this.$refs.baseActiveMenu.scrollLeft > 0;
        },
        showTagsRightArrow() {
            this.arrowUpdateTrigger;
            const tabContainer = this.$refs.baseActiveMenu;
            const tolerance = 5;
            return tabContainer && tabContainer.scrollWidth > tabContainer.clientWidth && tabContainer.scrollLeft + tolerance < tabContainer.scrollWidth - tabContainer.clientWidth;
        },
    },
    methods: {
        async fetchData() {
            await this.fetchOnlineData();
            await this.fetchOfflineData();

            this.$nextTick(() => {
                fitty('.channel-name');
                fitty.fitAll();
            });
        },
        async fetchOnlineData() {
            try {
                const channels = await this.fetchChannels();
                this.channels = channels;

                const tags = await this.fetchTags();
                this.tags = tags;
                this.groupedTags = this.groupTags(tags);

                const users = await this.fetchUsers();
                this.usersById = users;

                this.initializeOnlineTagsByUserId();
                this.setActiveMenuFromGroupedTags();

                this.isOnlineLoaded = true;
            } catch (error) {
                console.error("Error fetching online data:", error);
                this.isOnlineLoaded = false;
            }
        },
        async fetchOfflineData() {
            try {
                const offlineChannels = await this.fetchOfflineChannels();

                this.offlineChannels = offlineChannels;
                const onlineChannelIds = new Set(this.channels.map(channel => channel.userId));
                this.onlyOfflineChannels = offlineChannels.filter(channel => !onlineChannelIds.has(channel.userId));

                this.initializeOfflineTagsByUserId();

                this.isOfflineLoaded = true;
            } catch (error) {
                console.error("Error fetching offline data:", error);
                this.isOfflineLoaded = false;
            }
        },
        async fetchChannels() {
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/streams`);
            const data = await response.json();
            return data;
        },
        async fetchOfflineChannels() {
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/offlineUserData`);
            const data = await response.json();
            return data;
            //return [];
        },
        async fetchTags() {
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/terms`);
            const data = await response.json();
            return data.data;
        },
        async fetchUsers() {
            const response = await fetch(`${process.env.VUE_APP_NODE_SERVER_BASE_URL}/usersSlim`);
            const data = await response.json();
            return data;
        },
        initializeOnlineTagsByUserId() {
            this.channels.forEach(channel => {
                this.initializeTagsForChannel(channel);
            });
        },

        initializeOfflineTagsByUserId() {
            this.offlineChannels.forEach(channel => {
                this.initializeTagsForChannel(channel);
            });
        },

        initializeTagsForChannel(channel) {
            const userId = channel.userId;
            const tags = this.getTags(userId);
            tags.sort((a, b) => {
                if (a.importance === b.importance) {
                    return a.tag.localeCompare(b.tag);
                } else {
                    return a.importance - b.importance;
                }
            });
            this.tagsByUserId[userId] = tags;
        },
        groupTags(tags) {
            const groupedTags = _.groupBy(tags, 'tag_category.label');
            const sortedGroupedTags = {};
            const sortedLabels = Object.keys(groupedTags).sort();
            for (const label of sortedLabels) {
                sortedGroupedTags[label] = _.sortBy(groupedTags[label], 'title');
            }
            return sortedGroupedTags;
        },
        setActiveMenuFromGroupedTags() {
            const firstLabel = Object.keys(this.groupedTags)[0];
            this.activeMenu = { label: firstLabel, group: this.groupedTags[firstLabel] };
        },
        getPronoun(userId) {
            const user = this.usersById[userId];
            if (user && user.pronouns) {
                return user.pronouns.replace(/\//g, '/\u200B');
            } else {
                return 'N/A';
            }
        },
        getTags(userId) {
            const user = this.usersById[userId];
            if (!user || !user.tags) return [];
            return user.tags.sort((a, b) => a.importance - b.importance);
        },
        getFollows(userId) {
            const channel = this.offlineChannels.find(ch => ch.userId === userId);
            return channel ? channel.followers : 0;
        },
        getThumbnailUrl(url) {
            const width = 352;
            const height = 198;
            return url.replace('{width}', width).replace('{height}', height);
        },
        changeChannel(channelName) {
            const embedElem = document.getElementById('twitch-embed');
            if (embedElem && embedElem.twitchPlayer) {
                embedElem.twitchPlayer.setChannel(channelName);
                window.scrollTo(0, 0);
            }
        },
        addFilterCondition(operator) {
            const existingConditionIndex = this.filterConditions.findIndex(condition => condition.operator === operator);
            if (existingConditionIndex >= 0) {
                this.filterConditions[existingConditionIndex].selectedTags.splice(0);
                this.filterConditions.splice(existingConditionIndex, 1);
            } else {
                const firstLabel = Object.keys(this.groupedTags)[0];
                this.filterConditions.push({
                operator: operator,
                selectedTags: [],
                activeMenu: { label: firstLabel, group: this.groupedTags[firstLabel] }
                });
            }
            this.$nextTick(() => {
                this.updateArrowVisibility(this.filterConditions.length - 1);
            });
        },
        removeCondition(index) {
            this.filterConditions.splice(index, 1);
        },
        removeBaseTag(index) {
            this.selectedTags.splice(index, 1);
        },
        removeConditionTag(conditionIndex, tagIndex) {
            this.filterConditions[conditionIndex].selectedTags.splice(tagIndex, 1);
        },
        resetFilters() {
            this.selectedTags = [];
            this.filterConditions = [];
            this.searchQuery = "";
        },
        toggleTag(tag) {
            const index = this.selectedTags.indexOf(tag);
            if (index === -1) {
                this.selectedTags.push(tag);
            } else {
                this.selectedTags.splice(index, 1);
            }
        },
        setActiveConditionMenu(conditionIndex, label, group) {
            this.filterConditions[conditionIndex].activeMenu = { label, group };
            this.$nextTick(() => {
                this.updateArrowVisibility();
            });
        },
        toggleConditionTag(conditionIndex, tag) {
            const conditionTags = this.filterConditions[conditionIndex].selectedTags;
            const index = conditionTags.indexOf(tag);
            if (index === -1) {
            conditionTags.push(tag);
            } else {
            conditionTags.splice(index, 1);
            }
        },
        capitalizedOperator(operator) {
            const capitalizedOperator = operator.charAt(0).toUpperCase() + operator.slice(1);
            return capitalizedOperator;
        },
        selectTag(tag) {
            this.selectedTags.push(tag);
            const element = this.$refs.search;
            const top = element.offsetTop;
            window.scrollTo({ top, behavior: "smooth" });
        },
        setActiveMenu(label, group) {
            this.activeMenu = { label, group };
            this.$nextTick(() => {
                this.updateArrowVisibility();
            });
        },
        mostRecentDate(channel) {
            if (!channel) return null;

            let lastStreamDate = channel.last_stream;
            let archiveDate = channel.videoCreationDate ? new Date(channel.videoCreationDate).getTime() / 1000 : null;

            if (lastStreamDate && archiveDate) {
                return lastStreamDate > archiveDate 
                    ? lastStreamDate 
                    : archiveDate;
            }
            if (lastStreamDate) {
                return lastStreamDate;
            }
            if (archiveDate) {
                return archiveDate;
            }
            return null;
        },
        mostRecentDateLabel(channel) {
            if (!channel) return '';

            let archiveDate = channel.videoCreationDate ? new Date(channel.videoCreationDate).getTime() / 1000 : null;
            let mostRecentDate = this.mostRecentDate(channel);

            if (mostRecentDate === channel.last_stream) {
                return 'Last Stream';
            }
            if (mostRecentDate === archiveDate) {
                return 'Last Archive';
            }
            return '';
        },
        scrollTabsRight() {
            const tabContainer = this.$refs.tabContainer;
            const scrollAmount = tabContainer.clientWidth;
            tabContainer.scrollLeft += scrollAmount;
            this.updateArrowVisibility();
        },
        scrollTabsLeft() {
            const tabContainer = this.$refs.tabContainer;
            const scrollAmount = tabContainer.clientWidth;
            tabContainer.scrollLeft -= scrollAmount;
            this.updateArrowVisibility();
        },
        scrollTagsRight() {
            const tabContainer = this.$refs.baseActiveMenu;
            const scrollAmount = tabContainer.clientWidth;
            tabContainer.scrollLeft += scrollAmount;
            this.updateArrowVisibility();
        },
        scrollTagsLeft() {
            const tabContainer = this.$refs.baseActiveMenu;
            const scrollAmount = tabContainer.clientWidth;
            tabContainer.scrollLeft -= scrollAmount;
            this.updateArrowVisibility();
        },
        scrollConditionTabsLeft(conditionIndex) {
            const tabContainer = this.$refs['conditionTabContainer-' + conditionIndex];
            const scrollAmount = tabContainer[0].clientWidth;
            tabContainer[0].scrollLeft -= scrollAmount;
            this.updateArrowVisibility(conditionIndex);
        },
        scrollConditionTabsRight(conditionIndex) {
            const tabContainer = this.$refs['conditionTabContainer-' + conditionIndex];
            const scrollAmount = tabContainer[0].clientWidth;
            tabContainer[0].scrollLeft += scrollAmount;
            this.updateArrowVisibility(conditionIndex);
        },
        showLeftArrowForCondition(conditionIndex) {
            const tabContainer = this.$refs['conditionTabContainer-' + conditionIndex];
            return tabContainer[0] && tabContainer[0].scrollLeft > 0;
        },
        showRightArrowForCondition(conditionIndex) {
            const tabContainer = this.$refs['conditionTabContainer-' + conditionIndex];
            const tolerance = 5;
            return (
                tabContainer[0] &&
                tabContainer[0].scrollWidth > tabContainer[0].clientWidth &&
                tabContainer[0].scrollLeft + tolerance < tabContainer[0].scrollWidth - tabContainer[0].clientWidth
            );
        },
        scrollConditionTagsLeft(conditionIndex) {
            const tabContainer = this.$refs['conditionTagContainer-' + conditionIndex];
            const scrollAmount = tabContainer[0].clientWidth;
            tabContainer[0].scrollLeft -= scrollAmount;
            this.updateArrowVisibility(conditionIndex);
        },
        scrollConditionTagsRight(conditionIndex) {
            const tabContainer = this.$refs['conditionTagContainer-' + conditionIndex];
            const scrollAmount = tabContainer[0].clientWidth;
            tabContainer[0].scrollLeft += scrollAmount;
            this.updateArrowVisibility(conditionIndex);
        },
        showLeftArrowForConditionTags(conditionIndex) {
            const tabContainer = this.$refs['conditionTagContainer-' + conditionIndex];
            return tabContainer[0] && tabContainer[0].scrollLeft > 0;
        },
        showRightArrowForConditionTags(conditionIndex) {
            const tabContainer = this.$refs['conditionTagContainer-' + conditionIndex];
            const tolerance = 5;
            return (
                tabContainer[0] &&
                tabContainer[0].scrollWidth > tabContainer[0].clientWidth &&
                tabContainer[0].scrollLeft + tolerance < tabContainer[0].scrollWidth - tabContainer[0].clientWidth
            );
        },
        updateArrowVisibility() {
            this.arrowUpdateTrigger++;
            this.conditionArrowStates = this.conditionArrowStates || {};
            this.conditionTagArrowStates = this.conditionTagArrowStates || {};
            if (this.filterConditions) {
                for (let i = 0; i < this.filterConditions.length; i++) {
                    this.$set(this.conditionArrowStates, i, {
                        showLeftArrow: this.showLeftArrowForCondition(i),
                        showRightArrow: this.showRightArrowForCondition(i),
                    });
                    if (this.filterConditions[i].activeMenu) {
                        this.$set(this.conditionTagArrowStates, i, {
                            showLeftArrow: this.showLeftArrowForConditionTags(i),
                            showRightArrow: this.showRightArrowForConditionTags(i)
                        });
                    }
                }
            }
        },
    },
  };
</script>
<style scoped>
    button.active {
        background-color: var(--tabHighlightColor);
        color: var(--tabHighlightTextColor);
    }
    .btn {
        @apply text-center border border-black rounded-md bg-gray-100 text-gray-700 hover:bg-gray-300;
    }
    .tab {
        @apply border-x-2 border-t-2 border-black rounded-t-md bg-gray-100 mr-1 px-1 hover:bg-gray-300 font-medium;
    }
    .tabcontainer, .static-tags {
        @apply overflow-x-auto whitespace-nowrap lg:flex lg:flex-wrap px-1 lg:px-2 text-xs lg:text-sm;
    }
    /* Hide scrollbar for Chrome, Safari, and Opera */
    .tabcontainer::-webkit-scrollbar {
    display: none;
    }
    .static-tags::-webkit-scrollbar {
    display: none;
    }
    /* Hide scrollbar for Firefox */
    .tabcontainer, .static-tags {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    }
    /* For other browsers, hide the scrollbar but still make the container scrollable */
    .tabcontainer, .static-tags {
    overflow: -moz-scrollbars-none; /* Older Firefox */
    -webkit-overflow-scrolling: touch;
    }
    .static-tags{
        @apply overflow-x-auto whitespace-nowrap lg:flex lg:flex-wrap px-1 lg:px-2 text-xs lg:text-sm py-2;
    }
    .pronouns {
        overflow-wrap: break-word;
        word-wrap: break-word;
    }
    .arrow{
        @apply absolute top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-500 fill-current lg:hidden;
    }
</style>